import { FormikProps, FormikValues } from "formik";

import { ClientSelect } from "./ClientSelect";
import { formatClientOptionLabel } from "./ClientSelect.utils";

interface Props<T extends FormikValues> {
  formik: FormikProps<T>;
  idFieldName: keyof T & string;
  label: string;
  required?: boolean;
  freeSolo?: boolean;
  nameFieldName?: keyof T & string;
}

/**
 * Formik adapter over {@link ClientSelect}: binds the selected client id (and optional display name)
 * to form fields. For behaviour beyond that binding (e.g. autofilling related fields), use
 * {@link ClientSelect} directly.
 */
export function FormikClientSelect<T extends FormikValues>({
  formik,
  idFieldName,
  label,
  required,
  freeSolo,
  nameFieldName,
}: Props<T>) {
  const setName = (name: string | null) => {
    if (nameFieldName) {
      void formik.setFieldValue(nameFieldName, name);
    }
  };

  return (
    <ClientSelect
      label={label}
      required={required}
      freeSolo={freeSolo}
      onChange={(selection) => {
        if (selection && typeof selection !== "string") {
          void formik.setFieldValue(idFieldName, selection.clientId);
          setName(formatClientOptionLabel(selection));
        } else if (typeof selection === "string") {
          void formik.setFieldValue(idFieldName, null);
          setName(selection);
        } else {
          void formik.setFieldValue(idFieldName, null);
          setName(null);
        }
      }}
    />
  );
}
